
import { useState } from "react"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useDispatch } from "react-redux"
import { BsArrowRight } from "react-icons/bs";
const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;


        .content{
            padding: 20px 50px;
            color: ${({theme}) => theme.mainTextColor};

            .top-container{
                display: flex;
                justify-content: center;
                margin-bottom: 20px;

                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-lg);
            }

            .guide-container{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                width: 600px;
                line-height: 1.6;
                text-align: center;
            }

            .btn-container{
                margin-top: 20px;
                width: 100%;
                display: flex;
                justify-content: center;
            }
        }

    }
`

const NakliyeHesaplamaGuideModal = () => {

    const [activePage, setActivePage] = useState(0)

    const dispatch = useDispatch()

  return (
    <ModalContainer>
        <div className="modal">
            <div className="content">
                <div className="top-container">Nakliye Fiyatı Hesaplama</div>
                <div className="guide-container">Haritayı genişletmek için sayfada bulunan menüleri <span style={{textDecoration:"underline", fontWeight: "bold"}}>W kısayolu</span> ile görüntüle/gizle işlemi yapabilirsiniz.</div>
                <div className="btn-container">
                    <Btn bgColor="var(--color-main)" color="#fff" width={"200px"} handleClick={() => dispatch(showModal(null))}>Harika</Btn>
                </div>
            </div>
        </div>

    </ModalContainer>
  )
}

export default NakliyeHesaplamaGuideModal